import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ConnectImage from "../../shared-components/ConnectImage";
import classNames from "classnames";

export function GoogleAuth({ googleCta, nextUrl, source }) {
  useEffect(() => {
    if ($("#google-root").length === 0) {
      $.getScript("https://accounts.google.com/gsi/client");
      $("body").append("<div id='google-root'></div>");
    }
  }, []);

  const onGoogleAuth = () => {
    if (source === "login") {
      window.te.push("event", "landing", null, null, "login", {
        platform: "google"
      });
    }
    let tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: wattpad.googleClientId,
      scope: "profile openid email", // The things we want to retrieve from Google login.
      callback: response => {
        if (response.access_token) {
          const params = new URLSearchParams({
            type: "google",
            token: response.access_token
          });
          window.location.href =
            `/auth/google-auth?nextUrl=${wattpad.utils.getNextUrl(
              nextUrl,
              window.location.href
            )}&` + params.toString();
        }
      }
    });

    tokenClient.requestAccessToken();
  };

  return (
    <button
      onClick={onGoogleAuth}
      className={classNames("btn btn-google btn-block", "auth-button-new")}
    >
      <ConnectImage
        name="/shared/google_login_color.png"
        title="Google Login"
        width="18"
        className="google-login-icon"
        aria-hidden="true"
      />
      <span>
        <span className="auth-button-text-new">{googleCta}</span>
      </span>
    </button>
  );
}
GoogleAuth.propTypes = {
  googleCta: PropTypes.string.isRequired,
  nextUrl: PropTypes.string,
  source: PropTypes.string
};
